import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CORE_CONFIG_TOKEN } from '@ndk/ng-core/component/core.config';
import { Observable } from 'rxjs';

import { ICoreConfigInternal } from '@core/core.config.model';

import { ITranslatedLanguages } from './regional-settings.model';

@Injectable()
export class RegionalSettingsService {
    private apiUrl: string;

    constructor(@Inject(CORE_CONFIG_TOKEN) config: ICoreConfigInternal, private http: HttpClient) {
        this.apiUrl = `${ config.apiEndpoint }api/resources`;
    }

    public getTranslatedLanguages(): Observable<ITranslatedLanguages[]> {
        return this.http
            .get<ITranslatedLanguages[]>(`${ this.apiUrl }/translated-languages`);
    }
}
